/**
 * ============================================================
 * KML Renderer
 * MiningSurveyWebGIS
 * ============================================================
 */

import L from "leaflet";

import Feature from "./feature.js";
import Popup from "./popup.js";
import Label from "./label.js";
import Highlight from "./highlight.js";
import Event from "./event.js";

class Renderer {
    /**
     * ========================================================
     * Render KML
     * ========================================================
     */

    render(data, styles) {
        const group = L.featureGroup();

        // ===============================
        // Placemark langsung
        // ===============================

        data.placemarks.forEach((pm) => {
            this.renderPlacemark(pm, styles, group);
        });

        // ===============================
        // Folder
        // ===============================

        data.folders.forEach((folder) => {
            folder.placemarks.forEach((pm) => {
                this.renderPlacemark(pm, styles, group);
            });
        });

        return group;
    }

    /**
     * ========================================================
     * Render Placemark
     * ========================================================
     */

    renderPlacemark(placemark, styles, group) {
        //----------------------------------------------------
        // Style
        //----------------------------------------------------

        let style = {};

        if (placemark.styleUrl) {
            style = styles.get(placemark.styleUrl.replace("#", "")) || {};
        }

        //----------------------------------------------------
        // Feature
        //----------------------------------------------------

        const feature = Feature.create(placemark, style);

        if (!feature) return;

        // Jangan render Polygon
        if (feature.geometry?.type === "Polygon") {
            return;
        }
        Label.bind(feature, group);

        Event.bind(feature);

        group.addLayer(feature.layer);
    }
}

export default new Renderer();
